module.exports = __webpack_public_path__ + "img/tile_four.7f68a6d0.png";